<template>
  <!-- 无活动数据 -->
  <div class="page">
    <div class="paginations">
      <div class="addition">
        <el-button @click="see"> 无活动报告查看 <i class="h_icon el-icon-view"></i> </el-button>
      </div>
      <el-table :data="tableList" style="width: 100%">
        <el-table-column prop="zykNum" :label="Fristname" align="center">
          <template slot-scope="scope">
            <div class="download_div">
              <div @click="download(scope.row.zykId, 1)" style="margin-right: 10px">
                <i class="icona icon-download"></i>
                <span>下载建设院校未实名教师情况</span>
              </div>
              <div @click="download(scope.row.zykId, 2)">
                <i class="icona icon-download"></i>
                <span>下载建设院校近三年注册未实名学生情况</span>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="Secondname" align="center">
          <template slot-scope="scope">
            <div class="download_div">
              <div @click="downloadZombieResources(scope.row.zykId)">
                <i class="icona icon-download"></i>
                <span>下载僵尸资源</span>
              </div>
              <div @click="downloadActivityTeachers(scope.row.zykId)">
                <i class="icona icon-download"></i>
                <span>下载建设院校实名教师无活动情况</span>
              </div>
              <div @click="downloadActivityStudents(scope.row.zykId)">
                <i class="icona icon-download"></i>
                <span>下载建设院校近三年注册并已实名学生无活动情况</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pageNumber
        :paginations="7"
        :pageNum="pageDto.pageNum"
        :pageSize="pageDto.pageSize"
        :total="total"
        :jumpTo="jumpTo"
      ></pageNumber>
    </div>
  </div>
</template>

<script>
import pageNumber from "@/components/pageNumber.vue"; // 分页

export default {
  components: {
    pageNumber,
  },
  data() {
    return {
      formInSearch: {
        status: "",
        user: "",
      },
      tableList: [{ zykId: sessionStorage.getItem("zykId") }],
      pageDto: {
        pageNum: 1, // 当前显示的页面页码数
        pageSize: 10, // 一页多少条数据
      },
      DateStr: "",
      total: 0,
      jumpTo: 1,
      Fristname: "未实名数据下载",
      Secondname: "无活动数据下载",
      newDate:""
    };
  },
  created() {
    // this.getList();
    // 格式化时间日期
    // let str = '-'
    // let date = new Date()
    // let Year = date.getFullYear()
    // let Month = date.getMonth() + 1
    // let Day = date.getDate()
    // if (Month >= 1 && Month <= 9) Month = '0' + Month
    // if (Day >= 1 && Day <= 9) Day = '0' + Day
    // let currentDate = Year + str + Month + str + Day
    // this.DateStr = currentDate
    this.getTime();
    this.getCreateTime();
  },

  methods: {
    download(zykid, userType) {
      window.open(
        `${this.$apiurls.activeData_getUnitNoRealUserByType}?zykid=${zykid}&userType=${userType}`
      );
    },
    // 获取表格数据
    // getList(query) {
    //   this.pageDto.pageNum = query || 1;
    //   this.jumpTo = query || 1;
    //   this.$axios.post(this.$apiurls.activeData_getZykEntityDetail, {
    //     loading: false,
    //   }).then((res) => {
    //     if (res) {
    //       this.tableList = [];
    //       this.tableList.push(res.data);
    //     }
    //   });
    // },
    async getTime() {
      const res = await this.$axios.post(
        this.$apiurls.report_year_getUnitNoRealUserCreateTimeByType
      );
      if (res.data) {
        this.newDate=res.data
        this.Fristname = `${this.Fristname}  （截至：${this.newDate}）`;
      } else {
        return;
      }
    },
    async getCreateTime() {
      const res = await this.$axios.post(this.$apiurls.report_year_getNoAccessUserCreateTimeByType);
      if (res.data) {
        this.Secondname = `${this.Secondname} （截至：${res.data}）`;
      } else {
        return;
      }
    },
    see() {
      const obj = this.$router.resolve({
        path: "/noActiveDataReport",
        query: {
          zykid: sessionStorage.getItem("zykId"),
          token: sessionStorage.getItem("lrmv2token"),
          time:this.newDate,
          type:2
        },
      });
      window.open(obj.href, "_blank");
    },
    // 下载僵尸资源
    downloadZombieResources(zykid) {
      // console.log(row);
      window.open(`${this.$apiurls.activeData_getNoAccessResource}?zykid=${zykid}`);
    },
    // 下载教师无活动情况
    downloadActivityTeachers(zykid) {
      window.open(`${this.$apiurls.activeData_getNoAccessUserByType}?zykid=${zykid}&userType=1`);
    },
    // 下载学生无活动情况
    downloadActivityStudents(zykid) {
      window.open(`${this.$apiurls.activeData_getNoAccessUserByType}?zykid=${zykid}&userType=2`);
    },
  },
};
</script>

<style lang="scss" scoped>
.paginations {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .addition {
    margin-bottom: 20px;
    text-align: left;
  }
}

/* 修改表格头部背景 */
::v-deep .el-table th {
  background: rgba(31, 50, 94, 0.8);
  border-bottom: 0px !important;
  color: #fff;
  font-weight: 400;
}
/* 修改表格行背景 */
::v-deep .el-table tr {
  background: rgba(35, 42, 67, 1);
}

// 行间距
::v-deep .el-table__body {
  border-spacing: 0 5px;
}

.el-table,
.el-table__expanded-cell {
  background: transparent !important;
}
::v-deep .el-table::before {
  height: 0;
}

::v-deep .el-table--enable-row-hover .el-table__body tr td {
  border-bottom: 0px !important;
  color: #fff;
}

/* 修改表格鼠标悬浮hover背景色 */
::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
  background: rgba(31, 50, 94, 0.8);
}

.download_div {
  display: flex;
  justify-content: center;
  align-items: center;
}

.download_div div {
  margin: 0px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.download_div div:hover {
  color: #1bf6f8;
  cursor: pointer;
}

.download_div div i {
  width: 15px;
  height: 15px;
  margin: 0px;
}
</style>
